import {fetcher} from '@/src/shared/lib/fetcher/fetcher'
import {CustomerSummary} from '@/src/services/UserService/types'

const API_URL = process.env.NEXT_PUBLIC_API_URL

export const getUnreadMessages = () => {
  return fetcher<number>({
    url: `${API_URL}/messages/unread-count`,
    method: 'GET',
    isAuth: true,
  })
}

export const getCustomerSummary = (userId: string) => {
  return fetcher<CustomerSummary>({
    url: `${API_URL}/customers/${userId}/customer-summary`,
    method: 'GET',
    isAuth: true,
  })
}
